import React from 'react'
import styled from 'styled-components'

export default () => (
  <Container>
    <Main>
      <ButtonA
        href="https://www.prisma.io/docs/orm/overview/databases/sql-server?utm_source=blog&utm_medium=blog&utm_campaign=sqlserver-ga"
        target="_blank"
      >
        SQL Server connector Docs
      </ButtonA>
      <p>Learn more about how to configure the Prisma SQL Server connector</p>
    </Main>
    <Footer>
      <ButtonA
        href="https://www.prisma.io/docs/getting-started/setup-prisma/add-to-existing-project/relational-databases-typescript-sqlserver?utm_source=blog&utm_medium=blog&utm_campaign=sqlserver-ga"
        target="_blank"
      >
        Add Prisma to an existing SQL Server project
      </ButtonA>
      <ButtonA
        href="https://www.prisma.io/docs/getting-started/setup-prisma/start-from-scratch/relational-databases-typescript-sqlserver?utm_source=blog&utm_medium=blog&utm_campaign=sqlserver-ga"
        target="_blank"
      >
        Start from scratch
      </ButtonA>
    </Footer>
  </Container>
)

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 0px 0px 2.40026px rgba(0, 0, 0, 0.0115598), 0px 1.51px 6.63642px rgba(0, 0, 0, 0.0238066),
    0px 5.44px 15.9779px rgba(0, 0, 0, 0.0393306), 0px 22px 53px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
`

const Main = styled.div`
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    background: ${p => p.theme.green};
    color: white;
    font-weight: bold;
    padding: 16px 20px;
  }

  p {
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #718096;
    margin: 0;
    flex: 1;
    margin-left: 2rem;
  }

  @media screen and (max-width: 700px) {
    flex-direction: column-reverse;

    p {
      text-align: center;
      padding: 0 0 1.5rem;
      margin-left: 0;
    }
  }
`
const Footer = styled.div`
  padding: 2rem;
  display: flex;
  border-top: 1px solid #edf2f7;
  justify-content: space-between;

  @media screen and (max-width: 700px) {
    flex-direction: column;
    align-items: center;
    a {
      &:first-of-type {
        margin-bottom: 12px;
      }
    }
  }

  @media screen and (min-width: 701px) and (max-width: 800px) {
    a {
      padding: 12px 25px;
    }
  }
`

const ButtonA = styled.a`
  background: #e2e8f0;
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #2d3748;
  padding: 12px 40px;
  width: fit-content;
  &:hover,
  &:focus {
    cursor: pointer;
  }
`
